import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0;
  z-index: 1;

  @media (min-width: calc(${tokens.breakpoints.tablet}px + 1px)) {
    margin-left: 48px;
  }

  @media (min-width: calc(${tokens.breakpoints.desktop}px + 1px)) {
    margin-left: 72px;
    margin-top: 17px;
  }
`

export const Subtitle = styled.div`
  color: ${tokens.colors.dark6};
  font-size: ${tokens.fontSize.small};
  line-height: ${tokens.lineHeight.medium}%;
  display: inline-flex;
  flex-direction: column;
  padding-top: ${tokens.spacing.verticalXsmall};
  padding-bottom: ${tokens.spacing.verticalXsmall};

  @media (min-width: calc(${tokens.breakpoints.tablet}px + 1px)) {
    flex-direction: row;
    align-items: center;
    gap: ${tokens.spacing.horizontalXxsmall};
  }
`

export const Comment = styled.div`
  display: inline-flex;
  align-items: center;
`

export const Text = styled.p`
  margin: 0;
`
